<template>
  <v-container
    fluid
    style="min-height: 100vh; border-radius: 0; overflow: auto"
    :class="BeyondSelected ? 'applist' : ''"
  >
    <v-row class="d-flex justify-center" id="applist">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0" :class="BeyondSelected ? 'cardspace' : ''">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="Limit-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-container
            fluid
            style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
          >
            <v-container fluid style="border-radius: 0; padding: 16px">
              <v-row>
                <v-col cols="12">
                  <h1 class="Credit-Limit-Approve" style="text-align: left">
                    APPLICATION LIST
                  </h1>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col>
                  <v-data-table
                    :headers="headers"
                    :items="custRefNumbers"
                    class="elevation-1"
                    hide-actions
                    density="comfortable"
                    :items-per-page="5"
                    :footer-props="{
                      showFirstLastPage: true,
                      justify: 'center',
                    }"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td class="text-left">{{ item._REFNUMBER }}</td>
                        <td class="text-left">{{ item._STATUSDATE }}</td>
                        <td class="text-left">
                          <a
                            v-if="item._STATUS === 'Incomplete'"
                            @click="gotoOnlineAppScreen(item)"
                            target="_blank"
                            class="status-link"
                          >
                            <u>{{ item._STATUS }}</u>
                          </a>
                          <span v-else>{{ item._STATUS }}</span>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <v-btn
                    style="border-radius: 0; width: 250px; height: 30px"
                    @click="getRefNumber()"
                    color="#005F95"
                    class="white--text"
                  >
                    START NEW APPLICATION
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available
const refNumber = sessionStorage.getItem("refNumber");
const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const product = ref("");
const router = useRouter();
const prodtype = ref(sessionStorage.getItem("prodtype"));

const BeyondSelected = ref(false);

const headers = ref([
  { title: "REFERENCE NUMBER", key: "_REFNUMBER", width: "33.33%" },
  { title: "DATE", key: "_STATUSDATE", width: "33.33%" },
  { title: "STATUS", key: "_STATUS", width: "33.33%" },
]);

const custRefNumbers = ref([
  // Sample data
  // { _REFNUMBER: "12345", _STATUSDATE: "2024-07-01", _STATUS: "Incomplete" },
  // { _REFNUMBER: "67890", _STATUSDATE: "2024-07-02", _STATUS: "Complete" },
]);

onBeforeMount(() => {
  // Get product type from session storage
  prodtype.value = sessionStorage.getItem("prodtype");

  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
    beyond: "BEYOND CARD",
  };
  product.value = productMap[prodtype.value] || "CREDIT CARD";
  BeyondSelected.value = prodtype.value === "beyond";

  if (sessionStorage.getItem("otpauth") === "OTP_match") {
    getAppstatus();
  } else {
    router.push("/");
  }
});

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%---Function to get Previous Application List---%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%"

const GetUserForReferenceNumber = () => {
  const refNumber = sessionStorage.getItem("refNumber");

  axios
    .post("/GetUserForReferenceNumber", {
      _REFNUMBER: refNumber,
    })
    .then((response) => {
      if (response.data.data._USERID !== null) {
        // Handle the case where _USERID is not null
        console.log(response.data.data._USERID);
        // sessionStorage.setItem("userId", response.data.data._USERID)
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const getAppstatus = async () => {
  try {
    const userId = sessionStorage.getItem("userid");
    // const refNumber = sessionStorage.getItem("refNumber");
    const token = sessionStorage.getItem("authToken");

    if (!userId && !token) {
      console.error("Authirization Failed");
      return;
    }

    const response = await axios.post(
      "/getAppstatus",
      { _USER_ID: userId },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    // console.log(response.data.data._RESPONSE);

    if (response.data.data._RESPONSE === "RecordsFnd") {
      // Remove empty reference numbers
      custRefNumbers.value = response.data.data._APP_DATA.filter(
        (item) => item._REFNUMBER !== ""
      );

      // Set the first app status in sessionStorage
      if (custRefNumbers.value.length > 0) {
        // sessionStorage.setItem("appstatus", custRefNumbers.value[0]._STATUS);
      }
    } else {
      console.log("No Records Founds");
    }
  } catch (error) {
    console.error("Error fetching application status:", error);
  }
};

const getRefNumber = async () => {
  try {
    const response = await axios.post("/getRefNumber");

    if (
      response.data.data._RESPONSE === "SUCCESS" &&
      response.data.data._REFNUMBER
    ) {
      sessionStorage.setItem("refNumber", response.data.data._REFNUMBER);
      sessionStorage.setItem("apptype", "newapp");
      router.push("/SingleQuote");
      // console.log(response.data.data._REFNUMBER)
    }
  } catch (error) {
    console.error("Error fetching reference number:", error);
  }
};

const gotoOnlineAppScreen = (item) => {
  // Navigate to getquote page
  if (item._STATUS === "Incomplete") {
    sessionStorage.setItem("incompleteRef", item._REFNUMBER);
    // console.log('Stored incomplete ref:', item._REFNUMBER)
    // var incompleteRef = sessionStorage.getItem('incompleteRef')
    // console.log("My Incomplete App Ref : ",incompleteRef)
  }

  // GetUserForReferenceNumber();
  sessionStorage.setItem("appStatus", "Incomplete");
  router.push("/SingleQuote");
};
</script>
<style>
.applist {
  background: url("../assets/images/Beyondform.jpg") no-repeat center center;
  background-size: cover;
  padding-bottom: 250px;
}

h1 {
  color: #041e42;
}
.status-link {
  color: #1976d2; /* Vuetify primary blue */
  text-decoration: underline;
  cursor: pointer;
}
.cardspace {
  margin-top: 30px;
}
</style>
